<template>
  <div class="row">
    <div class="col-md-4">
      <organization-subject-input
          v-model="organization.subject_id"
          :form="form"
          :errors="errors"
          :items="organizationSubjects"
          :disabled="disabledSubject || disableOrganizationBlock"
          @change="changeSubject"
      />
    </div>
    <div class="col-md-8">
      <organization-name-input
          v-model="organization.name"
          :form="form"
          :errors="errors"
          :typeahead="typeaheadOrganizationName"
          :select-typeahead="selectTypeaheadOrganization"
          :location-name="locationName"
          :disabled="disabledName || disableOrganizationBlock"
          :input-label="organizationNameInputLabel"
          @switch-location-name="switchLocationName"
          @change="changeName"
          @blur="blurName"
      />
    </div>
    <div class="col-md-4">
      <organization-inn-input
          v-model="organization.inn"
          :form="form"
          :errors="errors"
          :typeahead="typeaheadOrganizationInn"
          :select-typeahead="selectTypeaheadOrganization"
          :disabled="disabledInn || disableOrganizationBlock"
          @change="changeInn"
          @blur="blurInn"
          @keyup="keyupInn"
      />
    </div>
    <div class="col-md-4">
      <organization-manager-position-input
          v-model="organization.position_of_manager"
          :form="form"
          :errors="errors"
          :prevValue="prevManagerPosition"
          :disabled="disabledPositionOfManager || disableOrganizationBlock"
          @change="change('organization position of manager')"
          @input="change('organization position of manager')"
      />
    </div>
    <div class="col-md-4">
      <organization-manager-name-input
          v-model="organization.director_name"
          :form="form"
          :errors="errors"
          :prevValue="prevManagerName"
          :disabled="disabledDirectorName || disableOrganizationBlock"
          @change="change('organization director name')"
          @input="change('organization director name')"
      />
    </div>
    <div class="col-md-8">
      <organization-address-input
          v-model="organization.address"
          :form="form"
          :errors="errors"
          :typeahead="typeaheadOrganizationAddress"
          :prevValue="prevAddress"
          :disabled="disabledAddress || disableOrganizationBlock"
          @change="change('organization address')"
          @input="change('organization address')"
          ref="organizationName"
      />
    </div>
    <div class="col-md-4">
      <organization-phone-input
          v-model="organization.phone"
          :form="form"
          :errors="errors"
          :disabled="disabledPhone || disableOrganizationBlock"
          @change="change('organization phone')"
      />
    </div>
  </div>
</template>

<script>
import applicationFormContextMixin from '@/common/mixins/applicationFormContextMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import mainMixin from '@/common/mixins/mainMixin'
import localApplicationFormMixin from '../../../../../mixins/localApplicationFormMixin'
import OrganizationSubjectInput from '@/common/components/application/form-inputs/organization/OrganizationSubjectInput.vue'
import OrganizationNameInput from '@/common/components/application/form-inputs/organization/OrganizationNameInput.vue'
import OrganizationInnInput from '@/common/components/application/form-inputs/organization/OrganizationInnInput.vue'
import OrganizationManagerPositionInput from '@/common/components/application/form-inputs/organization/OrganizationManagerPositionInput.vue'
import OrganizationManagerNameInput from '@/common/components/application/form-inputs/organization/OrganizationManagerNameInput.vue'
import OrganizationAddressInput from '@/common/components/application/form-inputs/organization/OrganizationAddressInput.vue'
import OrganizationPhoneInput from '@/common/components/application/form-inputs/organization/OrganizationPhoneInput.vue'
import { Logger } from '@/common/helpers/Logger'
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import { ResponseStatuses } from '@/common/enums/ResponseStatuses'
import { UserRoles } from '@/common/enums/UserRoles'

export default {
  name: 'OrganizationFormBlock',

  components: {
    OrganizationSubjectInput,
    OrganizationNameInput,
    OrganizationInnInput,
    OrganizationManagerPositionInput,
    OrganizationManagerNameInput,
    OrganizationAddressInput,
    OrganizationPhoneInput
  },
  mixins: [
    mainMixin,
    applicationFormMixin,
    applicationFormContextMixin,
    localApplicationFormMixin
  ],

  model: {
    prop: 'organization',
    event: 'change-organization'
  },

  props: {
    organization: {
      type: Object,
      required: true
    },

    organizationSubjects: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    locationName: 'all',
    locations: [],
    prevManagerPosition: '',
    prevManagerName: '',
    prevAddress: '',
    dadataINfo: ''
  }),

  computed: {
    disableOrganizationBlock () {
      return (this.user && this.user.role === UserRoles.TRUSTED_USER) ||
        this.isEdit
    },

    disabledAddress () {
      return Boolean(this.disabledInput) ||
          this.isTerminalSubject
    },

    disabledDirectorName () {
      return Boolean(this.disabledPositionOfManager) ||
          this.isTerminalSubject
    },

    disabledInn () {
      if (this.isFizOrganizationSubject) {
        return Boolean(
          this.disabledInput ||
            this.isTerminalSubject ||
            (this.user &&
                (this.user.role === UserRoles.TRUSTED_USER ||
                    ([
                      UserRoles.SUBDIVISION,
                      UserRoles.SB,
                      UserRoles.SB_TRUCK,
                      UserRoles.SB_OTHER
                    ].includes(this.user.role) &&
                        this.user.organization_id)))
        )
      }

      return Boolean(
        this.disabledInput || this.isTerminalSubject || this.isForeignSubject ||
          (this.user && (this.user.role === UserRoles.TRUSTED_USER ||
              ([
                UserRoles.SUBDIVISION,
                UserRoles.SB,
                UserRoles.SB_TRUCK,
                UserRoles.SB_OTHER
              ].includes(this.user.role) &&
                  this.user.organization_id)))
      )
    },

    disabledName () {
      if (this.isFizOrganizationSubject) {
        return Boolean(this.disabledInput)
      }

      return Boolean(
        this.disabledInput ||
          this.isTerminalSubject ||
          (this.user &&
              (this.user.role === UserRoles.TRUSTED_USER ||
                  ([
                    UserRoles.SUBDIVISION,
                    UserRoles.SB,
                    UserRoles.SB_TRUCK,
                    UserRoles.SB_OTHER
                  ].includes(this.user.role) &&
                      this.user.organization_id)))
      )
    },

    disabledPhone () {
      return Boolean(this.disabledInput) ||
          this.isTerminalSubject
    },

    disabledPositionOfManager () {
      return Boolean(
        this.disabledInput ||
          this.isTerminalSubject ||
          this.isFizOrganizationSubject ||
          this.isIndividualOrganizationSubject
      )
    },

    disabledSubject () {
      return Boolean(
        this.disabledInput ||
          (this.user && this.user.role === UserRoles.TRUSTED_USER) ||
          (this.user &&
              [
                UserRoles.SUBDIVISION,
                UserRoles.SB,
                UserRoles.SB_TRUCK,
                UserRoles.SB_OTHER
              ].includes(this.user.role) &&
              this.user.organization_id)
      )
    },

    organizationNameInputLabel () {
      return this.isEntityOrganizationSubject || this.isGkoOrganizationSubject || this.isTerminalSubject || this.isForeignSubject
        ? 'Наименование организации'
        : 'Фамилия, имя, отчество'
    }
  },

  mounted () {
    if (this.organization.inn && this.organization.inn.length > 0 && this.disableOrganizationBlock === false) {
      this.keyupInn()
    }
    if (this.organization.inn && (this.isNew || this.isDuplicate || this.isCheck)) {
      const vue = this
      this.getOrganizationSuggestions(this.organization.inn, true, true).then(function (result) {
        if (result) {
          vue.prevManagerName = result[0].data.management.name ? result[0].data.management.name : ''
          vue.prevManagerPosition = result[0].data.management.post ? result[0].data.management.post : ''
          vue.prevAddress = result[0].data.address.value ? result[0].data.address.value : ''

          vue.form.organization.dadataManagerName = vue.prevManagerName
          vue.form.organization.dadataManagerPosition = vue.prevManagerPosition
        }
      });
    }
  },

  methods: {
    blurInn ($event) {
      this.checkInnControlSum()
      this.$emit('blur', $event)
    },

    blurName ($event) {
      this.checkInnControlSum()
      this.$emit('blur', $event)
    },

    change (inputName) {
      Logger.log(`Changed ${inputName}!`)
      this.$emit('change-organization', this.organization)
    },

    changeInn ($event) {
      this.checkInnControlSum()
      this.$emit('input', $event)
    },

    async changeName ($event) {
      this.checkInnControlSum()
      this.$emit('change', $event)
      this.dadataINfo = await this.getOrganizationSuggestions(this.organization.name)
    },

    changeSubject () {
      this.$emit('change-subject')
      this.prevAddress = null
      this.prevManagerPosition = null
      this.prevManagerName = null
      this.form.organization.inn = null
      this.form.organization.name = null
      this.form.organization.address = null
      this.form.organization.director_name = null
      this.form.organization.phone = ''
      this.form.organization.position_of_manager = null
      this.form.organization.innError = false

      if (this.isFizOrganizationSubject) {
        this.form.organization.inn = ''
      }

      if (this.isTerminalSubject) {
        ApiClient.getTerminalOrganization().then((terminalOrganization) => {
          this.form.organization = Object.assign(this.form.organization, terminalOrganization.data)
        })
      }
    },

    keyupInn () {
      ApiClient.checkOrganizationInn({
        inn: this.organization.inn,
        user_id: this.user.id
      }).then((response) => {
        const result = response.data

        if (result.status === ResponseStatuses.Fail) {
          this.form.organization.innError = true
          this.form.organization.innHint = result.message
        } else {
          this.form.organization.innError = false
          this.form.organization.innHint = null
        }
      })
    },

    selectTypeaheadOrganization (item, inn = false) {
      if (this.isFizOrganizationSubject) {
        this.organization.name = item

        return
      }

      if (item === null) {
        if (!inn) {
          item = this.organization.data
        } else {
          item = this.organization.innData
        }
      }

      if (item instanceof Object) {
        this.organization.inn = item.data.inn
        this.organization.innData = item.data.inn
        this.organization.address = item.data.address
          ? item.data.address.value
          : null
        this.organization.position_of_manager = item.data.management
          ? item.data.management.post
          : null
        this.organization.director_name = item.data.management
          ? item.data.management.name
          : null
        this.organization.name =
            item.data.name &&
            (this.organization.subject_id === 'individual' ||
                !item.data.name.short_with_opf)
              ? item.data.name.full
              : item.data.name.short_with_opf
        this.form.organization.phone = item.data.phones
          ? String(item.data.phones.join(', '))
          : ''
        this.checkVisitorOrganizationBlock()
        this.checkInnControlSum()
        this.setPrevValues();
      }
    },

    setPrevValues () {
      this.prevAddress = this.organization.address
      this.prevManagerName = this.organization.director_name
      this.prevManagerPosition = this.organization.position_of_manager
      this.form.organization.dadataManagerName = this.prevManagerName
      this.form.organization.dadataManagerPosition = this.prevManagerPosition
    },

    switchLocationName () {
      this.locationName = this.locationName !== 'all' ? 'all' : this.configuration?.find_region ?? 'nw'
    }
  }
}
</script>
